import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CobaltLoadingIndicatorCircularComponent } from '@cae/cobalt-angular/components/loading-indicator-circular';

import { LoadingCircularPanelService } from './loading-circular-panel.service';

@Component({
  selector: 'app-loading-circular-panel',
  template: `
    <div *ngIf="isVisible" class="loading-container">
      <span class="loading-container-overlay"> </span>
      <cobalt-loading-indicator-circular
        size="large"
      ></cobalt-loading-indicator-circular>
    </div>
  `,
  styleUrls: ['./loading-circular-panel.component.less'],
  standalone: true,
  imports: [
    CobaltLoadingIndicatorCircularComponent,
    NgIf
  ]
})
export class LoadingCircularPanelComponent implements OnInit {
  @Input() isVisible = false;

  private _destroyRef = inject(DestroyRef);

  constructor(
    private _loadingCircularPanelService: LoadingCircularPanelService
  ) { }

  public ngOnInit(): void {
    this._loadingCircularPanelService.isLoadingCircularPanelVisible$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(
      (isVisible: boolean) => {
        this.isVisible = isVisible;
      }
    )
  }
}
